import { connect } from "extendable-media-recorder-wav-encoder";
import { MediaRecorder, register } from "extendable-media-recorder";

import { type IMediaRecorder } from "extendable-media-recorder";

import { log as info } from "@/Utils/Debug";
import { hasValue } from "@/Utils/Objects";

const log = (...args: unknown[]) => info("AudioRecord: ", ...args);

let mediaRecorder: IMediaRecorder | undefined;

const initRecorder = async (stream: MediaStream): Promise<boolean> => {
  if (!hasValue(stream)) {
    log("Error setup no stream");

    return false;
  }

  log("Start setup");

  try {
    await register(await connect());
  } catch (error) {
    log("Error setup wav encoder", error);
  }

  mediaRecorder = new MediaRecorder(stream, { mimeType: "audio/wav" });

  log("End setup.", `MediaRecorded ${hasValue(mediaRecorder) ? "initialized" : "Error"}`, stream);

  return hasValue(mediaRecorder);
};

export const startRecorder = async (stream: MediaStream, callbackBlob: (blob: Blob) => void) => {
  if (!hasValue(stream)) {
    log("Error record no stream");

    return;
  }

  if (!hasValue(mediaRecorder)) {
    const isInit = await initRecorder(stream);

    if (!isInit) {
      log("Error init record");

      return;
    }
  }

  mediaRecorder!.start(6000);

  mediaRecorder!.onstart = () => {
    log("Recorder started", mediaRecorder!.state);
  };

  mediaRecorder!.onerror = (event: Event) => {
    log("ERROR EVENT", event);
  };

  mediaRecorder!.ondataavailable = (event: BlobEvent) => {
    log("ON DATA", event);

    callbackBlob(event.data);
  };

  mediaRecorder!.onpause = () => {
    log("ON PAUSE");
  };

  mediaRecorder!.onresume = () => {
    log("ON RESUME");
  };

  mediaRecorder!.onstop = async () => {
    log("Recorder stopped");
  };
};

export const stopRecorder = () => {
  if (hasValue(mediaRecorder)) {
    mediaRecorder!.stop();

    mediaRecorder = undefined;
  }
};
